import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';
import { countBrandRows, countIpRows, flattenBrandRows, flattenIpRows } from '@/shein-platform/utils/sheinBrandIp';

export default function ShopBrandIpPanel({
  loading,
  error,
  brands,
  ips,
}) {
  const brandRows = flattenBrandRows(brands);
  const ipRows = flattenIpRows(ips);
  const brandCount = countBrandRows(brands);
  const ipCount = countIpRows(ips);

  return (
    <div className="spo-shop-info__panel" data-testid="shein-brand-ip">
      {loading ? <p className="spo-return-detail__empty">{fixedUi("正在查询品牌与 IP…")}</p> : null}
      {error ? <p className="spo-shop-info__inline-error" role="alert">{error}</p> : null}

      {!loading && !error ? (
        <div className="spo-shop-info__split">
          <div className="spo-shop-info__split-block">
            <h3 className="spo-return-detail__subhead">
              可用品牌
            </h3>
            {brandCount === 0 ? (
              <p className="spo-return-detail__empty">{fixedUi("暂无可用品牌")}</p>
            ) : (
              <div className="spo-shop-info__table-wrap">
                <table className="spo-shop-info__table">
                  <thead>
                    <tr>
                      <th>{fixedUi("品牌编码")}</th>
                      <th>{fixedUi("品牌名称")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {brandRows.map((row) => (
                      <tr key={row.key}>
                        <td><code>{row.brandCode}</code></td>
                        <td>{row.brandName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className="spo-shop-info__split-block">
            <h3 className="spo-return-detail__subhead">
              可用 IP
            </h3>
            {ipCount === 0 ? (
              <p className="spo-return-detail__empty">{fixedUi("暂无可用 IP")}</p>
            ) : (
              <div className="spo-shop-info__table-wrap">
                <table className="spo-shop-info__table">
                  <thead>
                    <tr>
                      <th>IP ID</th>
                      <th>{fixedUi("英文名称")}</th>
                      <th>{fixedUi("中文名称")}</th>
                      <th>{fixedUi("IP 组")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ipRows.map((row) => (
                      <tr key={row.key}>
                        <td><code>{row.ipId}</code></td>
                        <td>{row.ipName}</td>
                        <td>{row.ipNameCn}</td>
                        <td>{row.ipGroupName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
}
